import {toNumber} from 'lodash';
import {PLAN_TYPE_DESTINATION} from '../CreateRecommend/RecommendSourceDestination/constants';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {RECOMMENDATION_SUBTYPE_TO_SERVER} from '../../../constants/SolutionType';
import {UpsertOvrecommendVariables} from '../../../schema-types/UpsertOvrecommend';
import validateUUID from '../../../utils/validateUUID';
import {
  getPotContactId,
  updateRecommendPotsVariables,
  updateRecsVarsProps,
  getIsMinor,
} from './helpers';

const getProtectionVariables = async ({
  accountId,
  goalId,
  ovrecommendId,
  values,
  contacts = [],
}: updateRecsVarsProps): Promise<UpsertOvrecommendVariables> => {
  const {protectionPlan, contact, urgency, urgencyReason} = values;
  const isMinor = getIsMinor(contact, contacts);

  return {
    action: OVRecommendActionEnum.SET_UP_NEW,
    ovrecommendId: validateUUID(ovrecommendId),
    accountId: validateUUID(accountId),
    goalId: validateUUID(goalId),
    isNewPlanRequired: true,
    contactId: getPotContactId(contact, isMinor),
    urgency,
    urgencyReason,
    solutionType: RECOMMENDATION_SUBTYPE_TO_SERVER.PRODUCT_BASED,
    note: protectionPlan?.notes,
  };
};

export const generateProtectionOVRPots = async ({
  accountId,
  goalId,
  ovrecommendId,
  values,
  generateRecommendationPots,
  recommendDetails,
  reviewId,
  contacts = [],
}: updateRecommendPotsVariables) => {
  const {protectionPlan, contact} = values;
  const isMinor = getIsMinor(contact, contacts);

  const potId = recommendDetails?.pots?.find((x) => !!x.pot && !x.pot.parent)?.pot?.id;

  await generateRecommendationPots({
    variables: {
      accountId: validateUUID(accountId)!,
      ovrecommendId: validateUUID(ovrecommendId)!,
      args: [
        {
          planType: PLAN_TYPE_DESTINATION,
          potId: validateUUID(potId),
          isDummy: true,
          reviewId: validateUUID(reviewId),
          originalOvrId: validateUUID(ovrecommendId),
          inTrust: protectionPlan?.inTrust,
          contactId: values.contact ? validateUUID(values.contact) : null,
          protectionType: protectionPlan?.protectionType,
          monthlyIncome: protectionPlan?.monthlyIncome,
          waiverOfPremium: protectionPlan?.waiverOfPremium,
          livesAssured: protectionPlan?.livesAssured,
          premiumType: protectionPlan?.premiumType,
          lifeCover: protectionPlan?.lifeCover,
          terminatingAge: Number(protectionPlan?.terminatingAge),
          criticalIllnessCover: protectionPlan?.criticalIllnessCover,
          lifeOrCriticalIllnessCover: protectionPlan?.lifeOrCriticalIllnessCover,
          termType: protectionPlan?.termType,
          term: toNumber(protectionPlan?.term),
          investmentLinked: protectionPlan?.investmentLinked,
          deferredPeriod: protectionPlan?.deferredPeriod,
          notes: protectionPlan?.notes,
        },
      ],
    },
  });
};

export default getProtectionVariables;
